<template>
  <div>
    <div ref="bar" id="bar" style="height:300px;width:600px" v-show="false"></div>
    <div class="top">
      <l-navTop></l-navTop>
      <p class="title">{{topicinfo.title}}</p>
      <p class="time">正在答题：{{timeFormat(time)}}</p>
      <l-button value="退出测评" @click.native="$router.back()" />
    </div>
    <div class="wrap">
      <div class="left">
        <div v-for="(item,index) in topicList" :key="item.id" v-show="index==topicId">
          <p class="topic">{{index+1}}、{{item.question}} [单选题]</p>
          <ul>
            <li
              v-for="(answer,index) in item.answers"
              :key="index"
              @click="activeAnswer(answer,index)"
              :style="{'backgroundColor': (answerIndex[topicId] == index ? topicColor[index%topicColor.length] : '')}"
            >{{answer.option_answer}}</li>
          </ul>
        </div>
        <div class="jump">
          <l-button value="上一题" color="#3170FF" @click.native="prev()" />
          <l-button value="下一题" @click.native="next()" />
          <p>
            <el-checkbox v-model="isAuto"></el-checkbox>答题后自动跳到下一题
          </p>
          <l-button value="提交" color="#3170FF" @click.native="handSub()" />
        </div>
      </div>
      <div class="right">
        <p>答题卡</p>
        <ul>
          <li
            v-for="(item,index) in topicList.length"
            :key="index"
            @click="jumpTopic(index)"
            :class="answerIndex[index] >= 0 ? 'activeli' : ''"
          >{{index+1}}</li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import lNavTop from "../../../components/lNavTop.vue";
import lButton from "../../../components/lButton.vue";
let bar;
export default {
  data() {
    return {
      time: 0,
      timer: null,
      shake: false,
      isAuto: false,
      isInfo: true,
      topicList: [],
      topicinfo: {},
      topicId: 0,
      topicColor: [
        "rgba(255,105,180,0.5)",
        "rgba(123,104,238,0.5)",
        "rgba(221,160,221,0.5)",
        "rgba(100,149,237,0.5)",
        "rgba(255,165,0,0.5)",
        "rgba(60,179,113,0.5)",
      ],
      answerIndex: [],
      questionScore: [], //题目、分数合集
    };
  },
  methods: {
    //获取题目
    async getTopic() {
      let { data } = await this.$post("api/test/getSurveyByIdTable", {
        id: this.$route.query.id,
        publishId: this.$route.query.publishId,
      });
      console.log(data);
      this.topicList = data.data.list;
      this.topicinfo = data.data.Info[0];
      this.answerIndex = Array.from({ length: this.topicList.length }, () => {
        return -1;
      });

      this.getIncompleteData()
    },
    //上一题
    prev() {
      if (this.topicId == 0) {
        return;
      }
      this.topicId--;
    },
    //下一题
    next() {
      if (this.topicId == this.topicList.length - 1) {
        return;
      }
      this.topicId++;
    },
    //答题卡跳题
    jumpTopic(index) {
      this.topicId = index;
    },
    //选择答案
    activeAnswer(item, index) {
      this.$set(this.answerIndex, this.topicId, index);
      if (this.shake) return;
      if (this.isAuto && this.topicId < this.topicList.length - 1) {
        this.shake = true;
        setTimeout(() => {
          this.topicId++;
          this.shake = false;
        }, 200);
      }
      let obj = { question_id: this.topicId + 1, score: item.option_score };
      this.$set(this.questionScore, this.topicId, obj);

      this.setIncompleteData()
    },
    //提交
    async handSub() {
      let isAllAnswer = this.answerIndex.some(item => {
        return item < 0
      })
      if (isAllAnswer) {
        this.$myMessage("还有题目没有回答，请查看答题卡");
        return
      }

      this.$popup({
        title: '提示',
        content: '是否提交本次测评结果？',
        saveFoo: () => {
          this.setIncompleteData(true)
          this.$post("api/test/commitTableResult", {
            id: this.$route.query.id,
            publishId: this.$route.query.publishId,
            questionScore: this.questionScore,
            seconds: this.timeFormat(this.time),
          }).then(({data})=>{
            this.$getUserNum(3);
            let recordId = data.data.recordId
            let resultObj = JSON.parse(data.data.result)
            console.log(resultObj)

            let resultCategory = []
            for (let key in resultObj.resultCategory) {
              resultCategory.push(resultObj.resultCategory[key])
            }
            resultObj.resultCategory = resultCategory

            let result = resultObj.resultCategory.map((item) => {
              return [item.categoryName, item.categoryScores];
            });
            let base64 = this.handEcharts(result);
            this.$post("api/test/getRecordImage", {
              testType: 3,
              recordId: recordId,
              img: base64,
            });
            this.$router.back();
          })
        },
      })
    },
    handEcharts(record) {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        backgroundColor: "#fff",
        animation: false,
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      //导出echarts
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };

      // window.addEventListener("resize", function () {
      //   bar.resize();
      // });

      return bar.getDataURL(opts); //拿到base64 地址
    },
    //答题时间
    getTime() {
      this.timer = setInterval(() => {
        this.time += 1;
      }, 1000);
    },
    timeFormat (time) {
      let hour = Math.floor(time / (60 * 60)); //小时
      let min = Math.floor((time / 60) % 60); //分钟
      let sec = Math.floor(time % 60); //秒
      hour = hour < 10 ? '0' + hour : hour;
      min = min < 10 ? '0' + min : min;
      sec = sec < 10 ? '0' + sec : sec;
      return `${hour}:${min}:${sec}`;
    },

    //===================================
    // 做题时储存当前已完成结果，防止意外退出导致结果丢失
    setIncompleteData (isDel = false) {
      let jsonsData = localStorage.getItem('incompleteData')
      let nowUid = JSON.parse(localStorage.getItem('userinfo'))?.uid ?? ''
      let dataList = []
      if (jsonsData) {
        dataList = JSON.parse(jsonsData)
        let fIndex = dataList.findIndex((item)=>{
          return item.uid == nowUid
            && item.type == 'survey'
            && item.id == this.$route.query.id
            && item.publishId == this.$route.query.publishId
        })
        if (fIndex > -1) {
          dataList.splice(fIndex, 1)
        }
      }
      if (!isDel) {
        dataList.push({
          uid: nowUid,
          type: 'survey',
          id: this.$route.query.id,
          publishId: this.$route.query.publishId,
          answerIndex: this.answerIndex,
          questionScore: this.questionScore,
          time: this.time,
          cDate: new Date().getTime()
        })
      }
      localStorage.setItem('incompleteData', JSON.stringify(dataList));
    },
    getIncompleteData () {
      let jsonsData = localStorage.getItem('incompleteData')
      let nowUid = JSON.parse(localStorage.getItem('userinfo'))?.uid ?? ''
      if (jsonsData) {
        let dataList = JSON.parse(jsonsData)

        // 清除过期数据
        let nowDate = new Date().getTime()
        for (let i = 0; i < dataList.length; i++) {
          if (nowDate - dataList[i].cDate > (24 * 60 * 60 * 1000)) { // 最多24小时
            dataList.splice(i, 1)
          }
        }
        localStorage.setItem('incompleteData', JSON.stringify(dataList));

        let fIndex = dataList.findIndex((item)=>{
          return item.uid == nowUid
            && item.type == 'survey'
            && item.id == this.$route.query.id
            && item.publishId == this.$route.query.publishId
        })
        if (fIndex > -1) {
          let itemObj = dataList[fIndex]
          this.answerIndex = itemObj.answerIndex
          this.questionScore = itemObj.questionScore
          this.time = itemObj.time
        }
      }
    },

  },
  mounted() {
    this.getTopic();
    this.getTime();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: {
    lNavTop,
    lButton,
  },
};
</script>

<style lang="less" scoped>
.top {
  background: #3831ff;
  width: 1920px;
  height: 370px;
  text-align: center;
  color: #fff;
  .title {
    font-size: 22px;
    margin: 97px 0 32px 0;
  }
  .time {
    font-size: 18px;
    margin-bottom: 31px;
  }
  button {
    width: 145px;
  }
}
.wrap {
  display: flex;
  height: 710px;
  .left {
    width: 1245px;
    border-right: 1px solid #f0f0f0;
    color: #505050;
    box-sizing: border-box;
    padding: 56px 0 0 394px;
    overflow-y: auto;
    .topic {
      margin-bottom: 40px;
    }
    li {
      // height: 50px;
      width: 750px;
      background: rgba(240, 240, 240, 0.6);
      // line-height: 50px;
      margin-bottom: 20px;
      font-size: 15px;
      padding-left: 20px;
      box-sizing: border-box;
      border-radius: 10px;
      
      padding-top: 10px;
      padding-bottom: 10px;
      line-height: 30px;
    }
    .jump {
      display: flex;
      align-items: center;
      margin-top: 50px;
      button {
        height: 46px;
        width: 90px;
        margin: 0 9px;
      }
      p {
        margin-left: 26px;
        .el-checkbox {
          margin-right: 10px;
        }
      }
    }
  }
  .right {
    p {
      margin: 24px 0 29px 164px;
      color: #222222;
    }
    ul {
      width: 350px;
      display: flex;
      flex-wrap: wrap;
      margin-left: 48px;
      align-content: flex-start;
      height: 550px;
      overflow: auto;
    }
    li {
      width: 40px;
      height: 40px;
      color: #333333;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      margin: 0 20px 20px 0;
    }
    .activeli {
      background: #3170ff;
      color: #ffffff;
    }
  }
}

</style>